export default __webpack_public_path__ + "static/media/img9.2aba0f9f.png";